/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 7/21/2023
 */

import React from "react"
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"

const RejectModal = ({ open, isSubmit, handleReject, onClose }) => {
  return (
    <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
      <DialogTitle
        sx={{ backgroundColor: "#ca4343", color: "#fff" }}
        textAlign="center"
      >
        Are you sure you want to reject ?
      </DialogTitle>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancel
        </Button>
        <LoadingButton
          loading={isSubmit}
          loadingPosition="start"
          startIcon={<SaveIcon />}
          variant="contained"
          color="error"
          onClick={handleReject}
        >
          Reject
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default RejectModal
